import { FwdRollDealtPairModel } from "app/bfx-blotter-intervention/fwd-roll-pricing/models/FwdRollDealtPairModel";
import { FwdRollMutableRowModel } from "app/bfx-blotter-intervention/fwd-roll-pricing/models/FwdRollMutableRowModel";
import { FwdRollRowType } from "shared/cubiq-model-multi-asset";

export enum FwdRollPricingCmd {
  START,
  INITIALIZE,
  PORTFOLIO_UNLOCKED,
  UPDATE_TITLE,
  DISABLE_FOR_PRICING,
  PRICING_SUCCESS,
  PRICING_FAIL,
  PRICING_SAVE_FAIL,
  UNLOCK_FAIL,
  UNLOCK_SUCCESS,
  PRICES_SAVED,
  LOCKED_STATE_CHANGED,
  ROWS_UPDATED,
  EDITOR_DISABLED_CHANGED, // The boolean editorChanged flag on some models has changed
  SERVER_ROW_UPDATED,
  SERVER_ROW_DELETED,
  SERVER_ROW_ADDED,
  PORTFOLIO_REFRESH_ERROR, // Error when a refresh call fails
  REQUEST_FORWARD_FIRST_UNLOCK,
}

export interface RowUpdateData {
  row: FwdRollMutableRowModel;
  columnNames: string[];
}

export interface RowUpdatePayload {
  updatedRows: RowUpdateData[];
}

export interface RowUnlockPayload {
  row: FwdRollDealtPairModel;
  portfolioId: string;
}

export type FwdRollPricingPayloadType = string | RowUpdatePayload | RowUnlockPayload | null;

export class FwdRollPricingCmdPayload {
  public cmd: FwdRollPricingCmd = null;

  /** Can be used by grid components to ignore model changes for other row types */
  public rowType: FwdRollRowType = null;
  public payload: FwdRollPricingPayloadType = null;

  constructor(
    command: FwdRollPricingCmd,
    payload?: FwdRollPricingPayloadType,
    rowType?: FwdRollRowType,
  ) {
    this.cmd = command;
    this.payload = payload;
    this.rowType = rowType;
  }
}
